import { useState } from 'react'
import { PreviewLayoutCart } from '../common/ui-preview/sub-components/PreviewLayout'
import { ProgressBar } from '@shopflo/ui'
import { useCartContext } from 'src/lib/contexts/CartContext'
import { ItemCard } from '../common/ui-preview/sub-components/ItemCard'
import { OrderSummaryConfigType } from 'src/lib/types/customizeUI'
import Pill from '../common/ui-preview/skeletons/Pill'
import CartNotePreview from './CartNotePreview'

const defaultItems = [
  {
    price: 100,
    quantity: 0
  },
  {
    price: 200,
    quantity: 0
  },
  {
    price: 400,
    quantity: 0
  }
]

const ProgressBarView = () => {
  const {
    state: { progressBar },
    getters: { customizations, milestones, isCountBased }
  } = useCartContext()

  const orderSummaryConfig: OrderSummaryConfigType = {
    isOrderSummaryOpen: true,
    isQuantityEditable: true,
    isPriceStrikeThroughEnabled: false,
    showOrderSummaryAs: 'TILE',
    isOnePageCheckoutEnable: true
  }

  const [items, setItems] = useState(defaultItems)

  const handleItemEdit = (item: number, index: number) => {
    const newItems = [...items]
    const currentItem = newItems[index]
    if (currentItem.quantity + item < 0) {
      return
    }
    newItems[index].quantity += item
    setItems(newItems)
  }

  const total = items.reduce((acc, item) => acc + item.price * item.quantity, 0)

  const itemCount = items.reduce((acc, item) => acc + item.quantity, 0)

  return (
    <PreviewLayoutCart isProgressBarPreview={true} total={total}>
      <div className='flex flex-col justify-between items-center w-full'>
        <div className='flex flex-col w-full pb-6 overflow-hidden h-full'>
          <ProgressBar
            milestones={milestones}
            customizations={customizations}
            total={isCountBased ? itemCount : total}
          />
        </div>
        <div className='flex flex-col w-full px-4 space-y-4 h-full'>
          {items.map((item, index) => (
            <ItemCard
              key={index}
              orderSummaryConfig={orderSummaryConfig}
              className='flex justify-between'
              handleItemEdit={t => handleItemEdit(t, index)}
              quantity={item.quantity}
              price={item.price}
              disabled={!progressBar.isEnabled}
            />
          ))}
        </div>
        <div className='px-3 w-full'>
          <CartNotePreview />
        </div>
      </div>
    </PreviewLayoutCart>
  )
}

export default ProgressBarView
